import { useEffect } from "react";

const SITE_URL = "https://www.rnradianceaesthetics.com";

const DEFAULT_TITLE =
  "Radiance Aesthetics | Nurse-Led Skin Clinic in Hindley, Wigan | WN2 3XD";
const DEFAULT_DESCRIPTION =
  "Radiance Aesthetics — Premium nurse-led aesthetics clinic in Hindley, Wigan. Advanced facials, microneedling, skin peels, Dermalux LED therapy & skin boosters. Laurel House, Atherton Road, Hindley WN2 3XD. Book your consultation today.";
const DEFAULT_OG_TITLE =
  "Radiance Aesthetics | Nurse-Led Skin Clinic in Hindley, Wigan";
const DEFAULT_OG_DESCRIPTION =
  "Premium nurse-led aesthetics clinic on Atherton Road, Hindley, Wigan. Advanced facials, microneedling, skin peels & Dermalux LED therapy. Natural results, personalised care.";
const DEFAULT_TWITTER_TITLE =
  "Radiance Aesthetics | Nurse-Led Skin Clinic in Wigan & Hindley";
const DEFAULT_TWITTER_DESCRIPTION =
  "Premium nurse-led aesthetics clinic offering advanced facials, microneedling, skin peels & Dermalux LED therapy. Book your consultation.";
const DEFAULT_CANONICAL = `${SITE_URL}/`;

const setMetaContent = (selector, value) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    const [, attr, attrValue] = selector.match(/\[(\w+)="([^"]+)"\]/) || [];
    if (!attr) return;
    tag = document.createElement("meta");
    tag.setAttribute(attr, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

// This is a Create React App SPA with a single static index.html, so every
// route otherwise shares one <title>, meta description, canonical link, and
// Open Graph/Twitter card. That means an ad for "Profhilo in Wigan" lands on
// a page Google and social crawlers see as generically titled and
// canonicalised to the homepage, which hurts Quality Score and how the page
// previews when shared. This hook lets individual routes set their own.
const useDocumentMeta = (title, description) => {
  useEffect(() => {
    const canonicalUrl = title
      ? `${SITE_URL}${window.location.pathname}`
      : DEFAULT_CANONICAL;

    document.title = title || DEFAULT_TITLE;
    setMetaContent(
      'meta[name="description"]',
      description || DEFAULT_DESCRIPTION,
    );
    setMetaContent('meta[property="og:title"]', title || DEFAULT_OG_TITLE);
    setMetaContent(
      'meta[property="og:description"]',
      description || DEFAULT_OG_DESCRIPTION,
    );
    setMetaContent('meta[property="og:url"]', canonicalUrl);
    setMetaContent(
      'meta[name="twitter:title"]',
      title || DEFAULT_TWITTER_TITLE,
    );
    setMetaContent(
      'meta[name="twitter:description"]',
      description || DEFAULT_TWITTER_DESCRIPTION,
    );

    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute("href", canonicalUrl);

    return () => {
      document.title = DEFAULT_TITLE;
      setMetaContent('meta[name="description"]', DEFAULT_DESCRIPTION);
      setMetaContent('meta[property="og:title"]', DEFAULT_OG_TITLE);
      setMetaContent('meta[property="og:description"]', DEFAULT_OG_DESCRIPTION);
      setMetaContent('meta[property="og:url"]', DEFAULT_CANONICAL);
      setMetaContent('meta[name="twitter:title"]', DEFAULT_TWITTER_TITLE);
      setMetaContent(
        'meta[name="twitter:description"]',
        DEFAULT_TWITTER_DESCRIPTION,
      );
      canonicalTag.setAttribute("href", DEFAULT_CANONICAL);
    };
  }, [title, description]);
};

export default useDocumentMeta;
